import React from 'react';
import { Row, PillButton, CountBubble } from 'library/ui';
import { CalendarTodayOutlined, Add, CreditCardOutlined, FactCheckOutlined } from '@mui/icons-material';
import { usePostJobNavigation } from 'parent-portal/jobs/postJob/usePostJobNavigation';

export function ActionButtonRow({
    canPostJobs,
    canManagePayments,
    paymentSetupNeeded,
    awaitingUpdateCount = 0,
}: {
    canPostJobs: boolean;
    canManagePayments: boolean;
    paymentSetupNeeded: boolean;
    awaitingUpdateCount?: number;
}) {
    const { goToPostJob } = usePostJobNavigation();

    return (
        <Row gap="sm" wrap>
            {canPostJobs && (
                <PillButton icon={<Add sx={{ fontSize: 18 }} />} onClick={() => goToPostJob('Business Dashboard')}>
                    Post a Job
                </PillButton>
            )}
            {canManagePayments && paymentSetupNeeded && (
                <PillButton variant="secondary" icon={<CreditCardOutlined sx={{ fontSize: 18 }} />} to="/payments">
                    Setup Payment
                </PillButton>
            )}
            <PillButton variant="secondary" icon={<CalendarTodayOutlined sx={{ fontSize: 18 }} />} to="/jobs">
                View My Jobs
            </PillButton>
            {awaitingUpdateCount > 0 && (
                <PillButton
                    variant="secondary"
                    icon={<FactCheckOutlined sx={{ fontSize: 18 }} />}
                    to="/providers?clearinghouse=submitted"
                >
                    Clearinghouse Updates <CountBubble count={awaitingUpdateCount} />
                </PillButton>
            )}
        </Row>
    );
}
